<template>
<div class='card'>
    <div class='image'>
        <img :src='img' />
    </div>
    <div class='title'>
        {{ title }}
    </div>
    <div class='text'><slot></slot>
    </div>
</div>
</template>
<script>
export default {
  props: ['img', 'title']
}
</script>

<style lang="less" scoped>
@import "../css/globals.less";

div.card {
  flex: 1 0 0;
  display: flex;
  flex-direction: column;
  padding: 1em;
}

div.card div.image {
  padding: 10pt;
  order: 1;
  overflow: hidden;
  align-items: center;
  display: flex;
  justify-content: center;
}

div.card div.image img {
  width: 40vw;
  height: 40vw;
  object-fit: cover;
  border: solid 1px lightblue;
  padding: 1vw;
}

div.card div.title {
  padding: 0.1em;
  order: 2;
  align-items: center;
  justify-content: center;
  display: flex;
  font-family: @cursive-caption-font;
  font-size: @cursive-caption-font-size;
}

div.card div.text {
  padding: 1em;
  order: 3;
  text-align: center;
  display: flex;
  font-family: @serif-font;
  font-size: 15pt;
}
</style>


// WEBPACK FOOTER //
// src/components/Card.vue